import { Stack } from '@chakra-ui/react'
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon'

export const IdentIcon = ({ address, diameter = 24 }) => {
  return address ? (
    <Stack>
      <Jazzicon diameter={diameter} seed={jsNumberForAddress(address)} />
    </Stack>
  ) : null
}
